import store from '../../redux/store/store';
import { isUndefined, has } from 'lodash';

// checking association for the funds on bankSelection
export const bankAssociatedWithFund = (fund, bankSelection, agreementMap) => {
  // Mutually exclusive. Bank can either be associated already,
  // or associable, never both.
  fund.bankAssociable = false;
  fund.bankAssociated = false;
  if (!isUndefined(bankSelection) && !isUndefined(agreementMap)) {
    const selectedAgreement = agreementMap[bankSelection];
    if (selectedAgreement !== undefined) {
      selectedAgreement.associatedAgreements.map((itm) => {
        if (fund.uniqueKey === itm) {
          fund.bankAssociated = true;
        }
        return itm;
      });
      selectedAgreement.associableAgreements.map((itm) => {
        if (fund.uniqueKey === itm) {
          fund.bankAssociable = true;
        }
        return itm;
      });
      selectedAgreement.restrictedAgreements.map((itm) => {
        if (fund.uniqueKey === itm) {
          fund.bankAssociable = false;
          fund.bankAssociated = false;
        }
        return itm;
      });
    }
  }
  if (has(fund, 'newFund') && fund.newFund) {
    // this is needed because new fund registration eligibiity can change between banks otherwise new funds
    // would have been a blanket true when it comes to bank association
    const bankSelectionUIDs = [];
    const agreementList = agreementMap[bankSelection];
    if (!isUndefined(agreementList)) {
      agreementList.associableAgreements.forEach((UID) =>
        bankSelectionUIDs.push(UID)
      );
      agreementList.associatedAgreements.forEach((UID) =>
        bankSelectionUIDs.push(UID)
      );
    }

    if (has(fund, 'modelAgreementUniqueIDs')) {
      fund.modelAgreementUniqueIDs.forEach((modelUID) => {
        for (let i = 0; i < bankSelectionUIDs.length; i++) {
          if (bankSelectionUIDs[i] === modelUID) {
            fund.bankAssociated = true;
          }
        }
      });
    }
  }
  return fund;
};

// getting AgreementID for the quickBuy Selection
export const getFundByAgreementId = () => {
  const currentState = store.getState();
  const { quickBuy } = currentState;
  if (quickBuy !== undefined) {
    const { quickBuyAgreements } = quickBuy;
    if (quickBuyAgreements.length > 0) {
      return quickBuyAgreements[0];
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export const replaceSpecialCharacterWith = (str, repl) =>
  str.replace(/[&#,+()$~%.\\'":*?<>{}_]/g, repl);

export const replaceSpecialCharacterWithSpace = (str) =>
  replaceSpecialCharacterWith(str, ' ');
